import { BaseContainerModel } from "../base-container.model";
import { bl_applet_language_hdr_RowInterface, bl_applet_language_hdr_RowClass } from "../../dbschema/index";

export class AppletLanguageConatinerHdrModel extends BaseContainerModel {
    bl_applet_language_hdr: bl_applet_language_hdr_RowInterface = new bl_applet_language_hdr_RowClass();
}
